"use client";
import React, { useEffect, useState } from "react";
import { Card, Container, Spinner, Alert, Row, Col } from "react-bootstrap";
import { FaBookmark } from "react-icons/fa";
import { Link } from "react-router-dom";

const base_url = process.env.REACT_APP_BASE_URL;

const AuctionList = () => {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // console.log('nkkkdsd',data)
  console.log('sasvasvsavnkkkdsd',originalData)

  useEffect(() => {
    const fetchApprovedAuctions = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setError("User not logged in.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${base_url}/api/auction/userCreatedAuctions`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Failed to fetch approved auctions.");
        }

        const original = result.data || [];
        setOriginalData(original);

        const mapped = original.map((item) => ({
          id: item.id,
          auctionTitle: item.title || "N/A",
          objectType: item.details?.object_type || "N/A",
          artist: item.details?.artist || "N/A",
          category: item.category?.category_name || "N/A",
          auction_type: item.auction_type || "N/A",
          approval_status: item.approval_status || "N/A",
          description: item.details?.description || "No description available",
          image:  item.details?.image,
        }));

        setData(mapped.slice(0, 5));
      } catch (err) {
        setError(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedAuctions();
  }, []);

  return (
    <Container>
      <Card className="p-4 cus_form_crd">
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <Alert variant="danger">{error}</Alert>
        ) : (
          <Row>
            {data.map((auction) => (
             <>
              <Col md={6} lg={4} className="mb-4" key={auction.id}>
                <Link 
                  to={`/viewactiveauctions/${auction.id}`} 
                  style={{ textDecoration: 'none' }}
                >
                  <Card 
                    className="h-100 shadow-sm auction-card card_floral floral-border "
                    style={{ 
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                    }}
                  >
                    {/* Auction Image */}
                    <div 
                      style={{
                        height: '200px',
                        background: auction.image 
                          ? `url(${auction.image}) center/cover` 
                          : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        position: 'relative'
                      }}
                    >
                    
                      
                      {/* Status Badge */}
                      <div 
                        style={{
                          position: 'absolute',
                          top: '12px',
                          right: '12px'
                        }}
                      >
                        <span 
                          className={`badge ${
                            auction.approval_status === 'approved' 
                              ? 'bg-dark text-white' 
                              : auction.approval_status === 'pending'
                              ? 'bg-warning'
                              : 'bg-secondary'
                          }`}
                          style={{ fontSize: '0.75rem' }}
                        >
                          {auction.approval_status}
                        </span>
                      </div>
                    </div>

                    <Card.Body >
                      <Card.Title 
                        className="mb-2 text-start text-dark card-title"
                      >
                        {auction.auctionTitle}
                      </Card.Title>
                      
                      <Card.Text 
                        className="text-start mb-3"
                      >
                        {auction.description}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
             </>
              
            ))}
            
            {data.length === 0 && (
             <div className="d-flex justify-content-center align-items-center text-center" style={{ minHeight: '400px' }}>
                            <div>
                              <div className="mb-3">
                                <FaBookmark size={60} className="text-muted" />
                              </div>
                              <h4 className="text-dark mb-3">No Auctions Found</h4>
                              <Link
                                to='/home'
                                className="btn signup-btn text-white position-relative overflow-hidden border-0"
                              >
                                <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                                  <p className="m-0 text-black fw-bold button_name">
                                    Explore Auctions
                                  </p>
                                </div>
                              </Link>
                            </div>
                          </div>
            )}
          </Row>
        )}
      </Card>
    </Container>
  );
};

export default AuctionList;